
//finds first true in boolean list
export function findActiveIndexFromList (list) {
    for (let i = 0; i < list.length; i++)
        if (list[i]) return i;
    return -1;
}

export function findByID (list, id) {
    for (let i = 0; i < list.length; i++)
        if (list[i].id == id)
            return list[i];
    return null;
}

export function findIndexByID (list, id) {
    for (let i = 0; i < list.length; i++)
        if (list[i].id == id)
            return i;
    return -1;
}

export function findByTaskID (list, id) {
    for (let i = 0; i < list.length; i++)
        if (list[i].taskID == id)
            return i;
    return -1;
}

export function remove (list, index) {
    return list.slice(0, index).concat(list.slice(index+1, list.length));
}

export function isInList (list, object) {
        for (let i = 0; i < list.length; i++)
            if (list[i] && list[i] === object)
                return true;
        return false;
}



/** WEBPACK FOOTER **
 ** ./src/app/utils/list.js
 **/